import { useCallback } from "react";
import {
  DiagnosticsApi,
  DiagnosticsApiDiagnosticsLogFilesDownloadRequest,
  useAPIAction,
} from "melco-shared-logic";

export const useUserLogFilesDownload = (userIdToDownloadLogFile: string) => {
  const [logFilesDownload] = useAPIAction(
    DiagnosticsApi,
    async (
      api,
      logFilesDownloadActionDetails: DiagnosticsApiDiagnosticsLogFilesDownloadRequest
    ) => {
      console.log(logFilesDownloadActionDetails);

      const data = await api.diagnosticsLogFilesDownload(
        logFilesDownloadActionDetails
      );

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      defaultApiConfigOptions: { impersonationForId: userIdToDownloadLogFile },

      translationPrefix: "users.tabs.logfiles.actions.download",
    }
  );

  return useCallback(
    async (
      logFilesDownloadActionDetails: DiagnosticsApiDiagnosticsLogFilesDownloadRequest
    ) => {
      let response = null;

      try {
        response = await logFilesDownload(logFilesDownloadActionDetails);
      } catch (e) {
        console.log(e);

        //   // error handling is already done in useAPIAction
      }

      return response;
    },
    [logFilesDownload]
  );
};
